export interface GoogleMapsOptions {
  mapTypeControl: boolean;
  streetViewControl: boolean;
  rotateControl: boolean;
  fullscreenControl: boolean;
  zoomControl: boolean;
  mapId?: string;
}

const defaultOptions: GoogleMapsOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  zoomControl: false,
};

export default defaultOptions;
